export default __webpack_public_path__ + "static/media/bonjour.729b636c.png";